import { ChangeDetectionStrategy, Component, input, output, ViewEncapsulation } from '@angular/core';
import { StepHeaderComponent, StepStateViewModel } from '../step-header/step-header.component';
import { StepFooterComponent } from '../step-footer/step-footer.component';

@Component({
    selector: 'app-gbg-step',
    templateUrl: './gbg-step.component.html',
    styleUrls: ['./gbg-step.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    imports: [StepHeaderComponent, StepFooterComponent]
})
export class GbgStepComponent {
    readonly title = input.required<string>();
    readonly description = input.required<string>();
    readonly state = input.required<StepStateViewModel>();
    readonly nextEnabled = input.required<boolean>();
    readonly hasError = input.required<boolean>();
    readonly supportMessage = input.required<string>();

    readonly previousClicked = output<void>();
    readonly nextClicked = output<void>();

    previous(): void {
        this.previousClicked.emit();
    }

    next(): void {
        this.nextClicked.emit();
    }
}
